import { Injectable } from '@angular/core';
import { Operation, compare } from 'fast-json-patch';

@Injectable({ providedIn: 'root' })
export class HttpPatchUtilityService {
	static convertDataToHttpPatchOperation(
		originalDataObject: object,
		newDataObject: object
	): Array<Operation> {
		return compare(originalDataObject, newDataObject);
	}
}
